"use client";

import Link from "next/link";
import { useState } from "react";
import styles from "./Header.module.css";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [whatIsOpen, setWhatIsOpen] = useState(false);
  const [practicesOpen, setPracticesOpen] = useState(false);

  const toggleWhatIs = () => setWhatIsOpen(!whatIsOpen);
  const togglePractices = () => setPracticesOpen(!practicesOpen);

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link href="/" className={styles.logo}>
          <span className={styles.logoText}>
            <strong>FIP Bank</strong>
            <span className={styles.logoSubtext}>Banco de Buenas Prácticas de Innovación</span>
          </span>
        </Link>

        <button
          className={styles.mobileMenuButton}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? "✕" : "☰"}
        </button>

        <nav className={`${styles.nav} ${mobileMenuOpen ? styles.navOpen : ""}`}>
          <Link href="/" className={styles.navLink}>
            Inicio
          </Link>
          
          {/* Qué es - Dropdown */}
          <div 
            className={styles.dropdown}
            onMouseEnter={() => setWhatIsOpen(true)}
            onMouseLeave={() => setWhatIsOpen(false)}
          >
            <Link href="/what-is" className={styles.navLink}>
              Qué es <span className={styles.arrow}>▾</span>
            </Link>
            <div className={`${styles.dropdownMenu} ${whatIsOpen ? styles.dropdownMenuOpen : ""}`}>
              <Link href="/what-is#proyecto" className={styles.dropdownItem}>
                El Proyecto
              </Link>
              <Link href="/what-is#investigacion" className={styles.dropdownItem}>
                La Investigación
              </Link>
              <Link href="/what-is#informe" className={styles.dropdownItem}>
                Informe Final
              </Link>
            </div>
          </div>

          {/* Buenas Prácticas - Dropdown */}
          <div 
            className={styles.dropdown}
            onMouseEnter={() => setPracticesOpen(true)}
            onMouseLeave={() => setPracticesOpen(false)}
          >
            <Link href="/good-practices" className={styles.navLink}>
              Buenas Prácticas <span className={styles.arrow}>▾</span>
            </Link>
            <div className={`${styles.dropdownMenu} ${practicesOpen ? styles.dropdownMenuOpen : ""}`}>
              <Link href="/good-practices" className={styles.dropdownItem}>
                Explorar Prácticas
              </Link>
              <Link href="/good-practices#compartir" className={styles.dropdownItem}>
                Comparte tu Experiencia
              </Link>
            </div>
          </div>

          <Link href="/contact" className={styles.navLink}>
            Contacto
          </Link>
        </nav>
      </div>
    </header>
  );
}
